module.exports = __webpack_public_path__ + "img/funding-new11.29335ec4.png";